import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/seo/PageContainer';
import Slider from '../../component/SimpleSlider';
import Tanitim from '../../component/tanitim';
import WhyMobilassistance from '../../component/why';
import Online from '../../component/onlineislemler';
import IkameAracHizmeti from '../../component/ikamearac';
import PopularBlogs from '../../component/PopularBlogs';
import Hizmetlerimiz from '../../component/hizmetlerimiz';
import SiteSearch from '../../components/search/SiteSearch';
import '../../App.css';
import './HomePage.css';

/**
 * Homepage Component - Modernized
 * - SEO optimized
 * - Responsive design
 * - Same visual design as before
 */
const HomePage = React.memo(() => {
  const [width, setWidth] = useState(window.innerWidth);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  
  const handleWindowSizeChange = React.useCallback(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    // Scroll-to-top button visibility: sadece scroll pozisyonu, requestAnimationFrame ile throttle
    let rafId = null;
    const handleScroll = () => {
      if (rafId != null) return;
      rafId = requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        setShowScrollTop(scrollTop > 20);
        rafId = null;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // İlk yüklemede kontrol

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleWindowSizeChange]);

  return (
    <PageContainer 
      title="Ana Sayfa"
      description="6 farklı hizmet alanında hizmet veren Sektörünün öncüsü ve lideri olan Mobil Assistance'ın web sayfasına girmek için tıklayınız."
      keywords="mobil assistance, yol yardım, assistance hizmetleri, 7/24 yol yardım, çekici hizmeti, ikame araç"
      type="website"
    >
      {width > 800 ? <Slider /> : <div style={{ height: 250 }} />}
       
      {/* Floating Action Buttons */}
      <div className={`floating-action-buttons ${showScrollTop ? 'with-scroll-top' : ''}`}>
        <button
          onClick={() => setShowSearch(true)}
          className="floating-btn floating-btn-search"
          title="Site İçi Arama"
        >
          <i className="fas fa-search"></i>
          <span className="floating-btn-text">Ara</span>
        </button>
        <a 
          href="tel:08502550203" 
          className="floating-btn floating-btn-phone"
          title="Hemen Ara"
        >
          <i className="fas fa-phone"></i>
          <span className="floating-btn-text">Ara</span>
        </a>
        <a 
          href="https://wa.me/908502550203" 
          target="_blank" 
          rel="noopener noreferrer"
          className="floating-btn floating-btn-whatsapp"
          title="WhatsApp ile İletişime Geç"
        >
          <i className="fab fa-whatsapp"></i>
          <span className="floating-btn-text">WhatsApp</span>
        </a>
      </div>

      {/* Site Search Modal */}
      <SiteSearch show={showSearch} onHide={() => setShowSearch(false)} />

      <Online />
      <Tanitim />
      {width > 900 && <IkameAracHizmeti />}
      <Hizmetlerimiz />
      <WhyMobilassistance />
      <PopularBlogs />
    </PageContainer>
  );
});

HomePage.displayName = 'HomePage';

export default HomePage;

